import { CALL_API } from "redux-api-middleware";
import api from "apis/assignment";
import {
  REQUEST_ASSIGNMENT_CONFIG,
  RECEIVE_ASSIGNMENT_CONFIG,
  ERROR_ASSIGNMENT_CONFIG,
  REQUEST_CASE_LOCATIONS,
  RECEIVE_CASE_LOCATIONS,
  ERROR_CASE_LOCATIONS,
  REQUEST_INSPECTOR_LOCATIONS,
  RECEIVE_INSPECTOR_LOCATIONS,
  ERROR_INSPECTOR_LOCATIONS,
  REQUEST_ZIP_CODES,
  RECEIVE_ZIP_CODES,
  ERROR_ZIP_CODES,
  REQUEST_CASE_DETAILS,
  RECEIVE_CASE_DETAILS,
  ERROR_CASE_DETAILS,
  REQUEST_ASSIGNED_CASES,
  RECEIVE_ASSIGNED_CASES,
  ERROR_ASSIGNED_CASES,
  REQUEST_INSPECTOR_DETAILS,
  RECEIVE_INSPECTOR_DETAILS,
  ERROR_INSPECTOR_DETAILS,
  REMOVE_CASE_FROM_CASE_DETAILS,
  CLEAR_MAP_SELECTION,
  CLEAR_INSPECTOR_DETAILS,
  CLEAR_ASSIGNMENT_TOOL_MEMORY,
  REMOVE_CASES_FROM_MAP,
  REQUEST_ASSIGN_CASE,
  RECEIVE_ASSIGN_CASE,
  ERROR_ASSIGN_CASE,
  REQUEST_UNASSIGN_CASE,
  RECEIVE_UNASSIGN_CASE,
  ERROR_UNASSIGN_CASE,
  REQUEST_APPRAISAL_CASE_LOCATIONS_COUNT,
  RECEIVE_APPRAISAL_CASE_LOCATIONS_COUNT,
  ERROR_APPRAISAL_CASE_LOCATIONS_COUNT,
  REQUEST_INSURANCE_CASE_LOCATIONS_COUNT,
  RECEIVE_INSURANCE_CASE_LOCATIONS_COUNT,
  ERROR_INSURANCE_CASE_LOCATIONS_COUNT,
  PIN_TYPE_SELECTED_CHANGE,
  COUNTIES_SELECTED_CHANGE,
  DAYS_OLD_OPTION_SELECTED_CHANGE,
  DAYS_TILL_DUE_OPTION_SELECTED_CHANGE,
  EXTRA_FILTERS_SELECTED_CHANGE,
  CASE_ID_FILTER_CHANGE,
  SHOW_EXTRA_DETAILS_CHANGE,
  SELECTION_DETAILS_MODE_CHANGE,
  SELECTED_INSPECTOR_CHANGE,
  FR_GEO_COVERAGE_MODE,
  SERVICE_REGION_DRAWN,
  REQUEST_ASSIGNED_CASES_WITH_APPTS,
  RECEIVE_ASSIGNED_CASES_WITH_APPTS,
  ERROR_ASSIGNED_CASES_WITH_APPTS,
  UPDATE_ASSIGNED_CASES_WITH_APPTS_PINS,
} from "typeConstants";
import responseHandler from "responseHandler";
import { ASSIGNMENT_MODE_INSURANCE } from "components/Assignment";
import { HTTP_POST, WebApiReduxRequest } from "tools/webservice";

const updatePinsForAssignedCases = (selectedInspectorNumber, pinId, otherPinId) => {
  return dispatch => 
    dispatch({
      type: UPDATE_ASSIGNED_CASES_WITH_APPTS_PINS,
      payload: { 
        selectedInspectorNumber: selectedInspectorNumber,
        selectedInspectorPinId: pinId,
        otherPinId: otherPinId
      }
    });
};

const getCasesWithAppts = (stateCodeList, daysToLook) => {
  return WebApiReduxRequest(
    REQUEST_ASSIGNED_CASES_WITH_APPTS,
    RECEIVE_ASSIGNED_CASES_WITH_APPTS,
    ERROR_ASSIGNED_CASES_WITH_APPTS,
    HTTP_POST,
    api.assignedCasesWithAppts(),
    { 
      StateCodeList: stateCodeList,
      DaysToLook: daysToLook
    }
  );
};

const getConfig = (mode) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.config(mode),
        method: "GET",
        types: [
          REQUEST_ASSIGNMENT_CONFIG,
          {
            type: RECEIVE_ASSIGNMENT_CONFIG,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_ASSIGNMENT_CONFIG,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getCaseLocations = (mode, stateCodeList, caseIdFilter) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.caseLocations(mode),
        method: "POST",
        body: JSON.stringify({
          StateCodeList: stateCodeList,
          CaseIdFilter: caseIdFilter
        }),
        types: [
          REQUEST_CASE_LOCATIONS,
          {
            type: RECEIVE_CASE_LOCATIONS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_CASE_LOCATIONS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getInspectorLocations = (mode, stateCodeList, useBreadcrumbs, getCoverage = false) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.inspectorLocations(mode),
        method: "POST",
        body: JSON.stringify({
          StateCodeList: stateCodeList,
          UseBreadcrumbs: useBreadcrumbs,
          IncludeServiceRegions: getCoverage,
        }),
        types: [
          REQUEST_INSPECTOR_LOCATIONS,
          {
            type: RECEIVE_INSPECTOR_LOCATIONS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_INSPECTOR_LOCATIONS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getZipCodes = (stateCodeList) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.zipCodes(),
        method: "POST",
        body: JSON.stringify({
          StateAbbrevation: stateCodeList
        }),
        types: [
          REQUEST_ZIP_CODES,
          {
            type: RECEIVE_ZIP_CODES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_ZIP_CODES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getCaseDetails = (mode, caseIds) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.caseDetails(mode),
        method: "POST",
        body: JSON.stringify({
          CaseIds: caseIds
        }),
        types: [
          REQUEST_CASE_DETAILS,
          {
            type: RECEIVE_CASE_DETAILS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_CASE_DETAILS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getAssignedCases = (mode, inspectorNumber) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.assignedCases(mode, inspectorNumber),
        method: "GET",
        types: [
          REQUEST_ASSIGNED_CASES,
          {
            type: RECEIVE_ASSIGNED_CASES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_ASSIGNED_CASES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getInspectorDetails = (mode, inspectorNumber) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.inspectorDetails(mode, inspectorNumber),
        method: "GET",
        types: [
          REQUEST_INSPECTOR_DETAILS,
          {
            type: RECEIVE_INSPECTOR_DETAILS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_INSPECTOR_DETAILS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const removeCasesFromCaseDetailsList = (caseId) => {
  return dispatch => (
    dispatch({
      type: REMOVE_CASE_FROM_CASE_DETAILS,
      payload: caseId
    }));
};

const clearMapSelection = () => {
  return dispatch => (
    dispatch({
      type: CLEAR_MAP_SELECTION
    }));
};

const clearInspectorDetails = () => {
  return dispatch => (
    dispatch({
      type: CLEAR_INSPECTOR_DETAILS
    }));
};

const removeCasesFromMap = (caseIds) => {
  return dispatch => (
    dispatch({
      type: REMOVE_CASES_FROM_MAP,
      payload: caseIds
    }));
};

const assignCasesToInspector = (
  mode,
  caseIds,
  inspectorNumber,
  callback = null,
  caseAssignmentDetails = null,
  requireUnassignedCases = false,
) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.assign(mode),
        method: "POST",
        body: JSON.stringify({
          CaseIds: caseIds,
          InspectorNumber: inspectorNumber,
          CaseAssignmentDetails: caseAssignmentDetails,
          RequireUnassignedCases: requireUnassignedCases,
        }),
        types: [
          REQUEST_ASSIGN_CASE,
          {
            type: RECEIVE_ASSIGN_CASE,
            payload: (action, state, res) => {
              return res.json()
                .then(data => {
                  if (callback) {
                    callback(data);
                  }
                  return data;
                });
            }
          }, {
            type: ERROR_ASSIGN_CASE,
            payload: (action, state, res) => {
              if (callback) callback();
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const unassignCases = (mode, caseIds, callback = null) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.unassign(mode),
        method: "POST",
        body: JSON.stringify(caseIds),
        types: [
          REQUEST_UNASSIGN_CASE,
          {
            type: RECEIVE_UNASSIGN_CASE,
            payload: (action, state, res) => {
              if (callback) callback();
              return res.json()
                .then(data => {
                  return data;
                });
            }
          }, {
            type: ERROR_UNASSIGN_CASE,
            payload: (action, state, res) => {
              if (callback) callback();
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const clearAssignmentToolMemory = () => {
  return dispatch => dispatch({ type: CLEAR_ASSIGNMENT_TOOL_MEMORY });
};

const getCaseLocationsCount = (mode, stateCodeList, caseIdFilter) => {
  let request, recieve, error;
  if (mode === ASSIGNMENT_MODE_INSURANCE) {
    request = REQUEST_INSURANCE_CASE_LOCATIONS_COUNT;
    recieve = RECEIVE_INSURANCE_CASE_LOCATIONS_COUNT;
    error = ERROR_INSURANCE_CASE_LOCATIONS_COUNT;
  } else {
    request = REQUEST_APPRAISAL_CASE_LOCATIONS_COUNT;
    recieve = RECEIVE_APPRAISAL_CASE_LOCATIONS_COUNT;
    error = ERROR_APPRAISAL_CASE_LOCATIONS_COUNT;
  }
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.caseCount(mode),
        method: "POST",
        body: JSON.stringify({
          StateCodeList: stateCodeList,
          CaseIdFilter: caseIdFilter
        }),
        types: [
          request,
          {
            type: recieve,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: error,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

export const updatePinTypeSelected = payload => dispatch => dispatch({
  type: PIN_TYPE_SELECTED_CHANGE,
  payload,
});

export const updateCountiesSelected = payload => dispatch => dispatch({
  type: COUNTIES_SELECTED_CHANGE,
  payload,
});

export const updateDaysOldOptionSelected = payload => dispatch => dispatch({
  type: DAYS_OLD_OPTION_SELECTED_CHANGE,
  payload,
});

export const updateDaysTillDueOptionSelected = payload => dispatch => dispatch({
  type: DAYS_TILL_DUE_OPTION_SELECTED_CHANGE,
  payload,
});

export const updateExtraFiltersSelected = payload => dispatch => dispatch({
  type: EXTRA_FILTERS_SELECTED_CHANGE,
  payload,
});

export const updateCaseIdFilter = payload => dispatch => dispatch({
  type: CASE_ID_FILTER_CHANGE,
  payload,
});

export const updateShowExtraDetails= payload => dispatch => dispatch({
  type: SHOW_EXTRA_DETAILS_CHANGE,
  payload,
});

export const updateSelectionDetailsMode = payload => dispatch => dispatch({
  type: SELECTION_DETAILS_MODE_CHANGE,
  payload,
});

export const updateSelectedInspector = payload => dispatch => dispatch({
  type: SELECTED_INSPECTOR_CHANGE,
  payload,
});

export const frGeoCoverageMode = (payload) => {
  return {
    type: FR_GEO_COVERAGE_MODE,
    payload,
  };
};

export const saveFRServiceBoundary = (payload) => ({
  type: SERVICE_REGION_DRAWN,
  payload,
});

export {
  updatePinsForAssignedCases,
  getCasesWithAppts,
  getConfig,
  getCaseLocations,
  getInspectorLocations,
  getZipCodes,
  getCaseDetails,
  getAssignedCases,
  getInspectorDetails,
  removeCasesFromCaseDetailsList,
  clearMapSelection,
  clearInspectorDetails,
  assignCasesToInspector,
  unassignCases,
  removeCasesFromMap,
  clearAssignmentToolMemory,
  getCaseLocationsCount
};
